import React from "react";
import LayoutPreLoad from "./layout.preload";
import LayoutTopbar from "./layout.top-bar";
import LayoutNavbar from "./layout.navbar";
import LayoutFooter from "./layout.footer";
import LayoutBackToTop from "./layout.back-to-top";
import DialogLogin from "../Dialog/dialog.login";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "../../store/actions";
import "./layout.css";
import { withRouter } from "react-router-dom";
import _ from "lodash";

class LayoutMain extends React.Component {
  componentDidMount() {
    this.handlerSet();
  }

  componentDidUpdate(prevProps) {
    !_.isEqual(this.props.location, prevProps.location) && window.scrollTo(0, 0);
  }

  handlerSet = async () => {
    const { FirebaseAuthCurrentUser, getNavbarCategory, dispatch, GetCartData } = this.props;
    await FirebaseAuthCurrentUser();
    await getNavbarCategory();
    const classNameOfTop = window.innerWidth < 992 ? ['.navbar-header', '.top-bar.hidden-xs'] : ['.nav-fixed-layout'];
    const topHeight = _.sum(classNameOfTop.map(item => document.querySelector(item)?.offsetHeight || 0)) - 1;
    await dispatch({ type: Actions.HOME.SET_HEIGHT_OF_CONTAINER, payload: `calc(100vh - ${topHeight}px)` });
    const footterHeight = document.querySelector(".footer.footer-type-3")?.offsetHeight || 0;
    await dispatch({ type: Actions.HOME.SET_MIN_HEIGHT_OF_CONTAINER, payload: `calc(100vh - ${topHeight + footterHeight}px)` });
    await GetCartData();
  }

  render() {
    const { containerMinHeight } = this.props;
    return (
      <>
        <LayoutPreLoad />
        <DialogLogin />
        <div className="nav-fixed-layout">
          <header className="nav-type-3">
            <LayoutTopbar />
            <LayoutNavbar />
          </header>
        </div>
        <div className="main-wrapper-layout">
          <div className="main-wrapper shop oh">
            <div style={{ minHeight: containerMinHeight }}>
              {this.props.children}
            </div>
            <LayoutFooter />
            <LayoutBackToTop />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ home, language, login }) => {
  return {
    containerMinHeight: home.containerMinHeight,
    currentLanguage: language.currentLanguage
  }
}

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        getNavbarCategory: Actions.getNavbarCategory,
        FirebaseAuthCurrentUser: Actions.FirebaseAuthCurrentUser,
        GetCartData: Actions.GetCartData
      },
      dispatch
    ),
    dispatch
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LayoutMain));
